import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { InvestigationFormRepository } from '../../../infrastructure/repositories/investigation-form.repository';
import { InvestigationFormState } from '../../states/investigation-form.state';
import { RemoveFieldCommand } from './remove-field.command';

@Injectable({ providedIn: 'root' })
export class RemoveFieldUseCase {
  private readonly _repository = inject(InvestigationFormRepository);
  private readonly _state = inject(InvestigationFormState);

  public execute(command: RemoveFieldCommand): Observable<void> {
    this._state.setLoadingInvestigationForm(true);
    this._state.clearErrorInvestigationForms();

    return this._repository.removeField(command.versionId, command.fieldId).pipe(
      catchError((error) => {
        const errorMessage =
          error?.error?.message ||
          error?.message ||
          `Failed to remove field ${command.fieldId}`;
        this._state.setErrorInvestigationForms(errorMessage);
        return throwError(() => error);
      }),
      finalize(() => this._state.setLoadingInvestigationForm(false))
    );
  }
}
